const globalStandardLogoAndStyles = {
  name: 'SIOON',
  logo: {},
  primary_color: '#DEDEDE',
  secondary_color: '#8D8F91',
  subdomain: 'ringaobras',
};

export default globalStandardLogoAndStyles;
